
    import { mapGetters,mapActions } from 'vuex'
    export default {
    props: {
      modal: {
        default: 'FormsVideoSubmission',
        type: String,
      },
      text: {
        default: 'Enter now!',
        type: String,
      },
      classes: {
        default: 'button new large solid fullwidth',
        type: String
      }
    },
    data() {
      return {
        isActive: this.active !== ''
      }
    },
  
    computed: {
      ...mapGetters({
        activeModal : 'pages/getActiveModal',
      }),
    },
    methods:{
        ...mapActions({
          updateActiveModal: 'pages/updateActiveModal', // map `this.add()` to `this.$store.commit('increment')`
        }),
        updateModal(id){
          // const newId = this.$nuxt.$options.filters.convertModal(id)
          this.updateActiveModal(id)
          console.log('Active Modal: ',this.activeModal)
        }
    },
  }
  